import { ReviewsSummary as TReviewsSummary } from "@omni/types/api/reviews/bff/response/reviewsSummary.model";

import { ReviewsSummaryComponent } from "./reviewsSummary.component";

type Props = {
    reviewsSummary: TReviewsSummary;
};

export const ReviewsSummary = ({ reviewsSummary }: Props) => {
    return <ReviewsSummaryComponent reviewsSummary={reviewsSummary} />;
};
